module.exports = __webpack_public_path__ + "img/image0.f7d4b2f7.png";